import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import NibbleInput from "../../../components/Fields/NibbleInput";
import {
  getSalidaTicketConfig,
  putSalidaTicketConfig,
} from "../../../helpers/backend_helper";

// Tamaño de letra del ticket de la salida. Se guarda por ruta (la de la salida).
const TicketConfigModal = ({ isOpen, setOpen, salidaId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (formValues) => {
    setIsLoading(true);
    putSalidaTicketConfig(salidaId, { font_size: formValues.font_size })
      .then((resp) => {
        if (resp.status) handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const validation = useFormik({
    initialValues: { font_size: 14 },
    validationSchema: Yup.object({
      font_size: Yup.number()
        .integer()
        .min(8)
        .max(24)
        .required()
        .label("Tamaño de fuente"),
    }),
    onSubmit,
  });

  const fetchConfig = () => {
    getSalidaTicketConfig(salidaId).then((resp) => {
      if (resp.status && resp.font_size) {
        validation.setFieldValue("font_size", resp.font_size);
      }
    });
  };

  useEffect(fetchConfig, [salidaId]);

  return (
    <div>
      <Modal isOpen={isOpen} className="modal-dialog">
        <ModalHeader className="bg-primary">
          Configuración para impresión de ticket
        </ModalHeader>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            id="ticket-config-form"
          >
            <div className="row">
              <NibbleInput
                md={12}
                label="Tamaño de fuente (px):"
                fieldName="font_size"
                fieldType="number"
                validation={validation}
              />
            </div>
            <small className="text-muted">
              Aplica a todos los tickets de la ruta de esta salida.
            </small>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            type="submit"
            form="ticket-config-form"
            disabled={isLoading}
          >
            {isLoading && <Spinner size="sm"></Spinner>}{" "}
            <i className="fa fa-save"></i> Guardar Cambios
          </Button>
          <Button color="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TicketConfigModal;
